import { GlueErrorDetail, GlueErrorResponse } from '@/src/lib/glue/types';

export function isGlueErrorResponse(response: unknown): response is GlueErrorResponse {
  return response instanceof Object && 'errors' in response;
}

export function isGlueErrorDetail(error: unknown): error is GlueErrorDetail {
  return error instanceof Object && 'detail' in error;
}
